import { WidgetsNotFoundMain } from '@/widgets/not-found';

export const PagesNotFoundMain = () => <WidgetsNotFoundMain />;
